import React from 'react'

function OperationList({ operations, understanding, onApprove, onReject, isExecuting }) {
  return (
    <div className="flex justify-start mb-3">
      <div className="max-w-[85%] w-full">
        {understanding && (
          <div className="bg-gray-100 rounded-2xl px-4 py-2.5 mb-2">
            <div className="text-sm text-gray-900 whitespace-pre-wrap leading-relaxed">
              {understanding}
            </div>
          </div>
        )}

        <div className="border border-gray-200 rounded-xl overflow-hidden">
          <div className="px-4 py-2 bg-gray-50 border-b border-gray-200">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
              Proposed Changes ({operations.length})
            </span>
          </div>

          <div className="divide-y divide-gray-100">
            {operations.map((op, i) => (
              <div key={i} className="px-4 py-2.5 text-sm">
                <div className="font-medium text-gray-900">{op.description}</div>
                {op.type === 'CREATE_PRODUCT' && op.productData && (
                  <div className="mt-1 flex flex-wrap gap-1.5 text-xs">
                    <span className="bg-green-100 text-green-700 px-1.5 py-0.5 rounded">+ New Product</span>
                    {op.productData.name?.en && (
                      <span className="text-gray-600">{op.productData.name.en}</span>
                    )}
                    {op.productData.price && (
                      <span className="text-gray-500">${op.productData.price}</span>
                    )}
                  </div>
                )}
                {op.type === 'CREATE_SUBMENU' && op.subMenuData && (
                  <div className="mt-1 flex flex-wrap gap-1.5 text-xs">
                    <span className="bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded">+ New Category</span>
                    {op.subMenuData.name?.en && (
                      <span className="text-gray-600">{op.subMenuData.name.en}</span>
                    )}
                    {op.subMenuData.section && (
                      <span className="text-gray-500">({op.subMenuData.section})</span>
                    )}
                  </div>
                )}
                {op.oldValue !== undefined && op.newValue !== undefined && (
                  <div className="mt-1 text-xs text-gray-500">
                    <span className="line-through text-red-400">{String(op.oldValue)}</span>
                    {' → '}
                    <span className="text-green-600 font-medium">{String(op.newValue)}</span>
                  </div>
                )}
                <div className="mt-0.5 text-xs text-gray-400">
                  {op.type}{op.docId ? ` · ${op.docId}` : ''}
                </div>
              </div>
            ))}
          </div>

          <div className="px-4 py-3 bg-gray-50 border-t border-gray-200 flex gap-2">
            <button
              onClick={onApprove}
              disabled={isExecuting}
              className="
                px-4 py-1.5 text-sm font-medium rounded-lg
                bg-gray-900 text-white
                hover:bg-gray-800
                disabled:opacity-50 disabled:cursor-not-allowed
                transition-colors
              "
            >
              {isExecuting ? 'Applying...' : 'Approve'}
            </button>
            <button
              onClick={onReject}
              disabled={isExecuting}
              className="
                px-4 py-1.5 text-sm font-medium rounded-lg
                border border-gray-300 text-gray-700
                hover:bg-gray-100
                disabled:opacity-50 disabled:cursor-not-allowed
                transition-colors
              "
            >
              Reject
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OperationList
